import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { loadMindlyReviewThunk, reviewMindlyThunk } from './thunk';

type MindlyReviewsState = {
  isReviewed: boolean;
  isModalOpened: boolean;
};
const initialState: MindlyReviewsState = {
  isReviewed: false,
  isModalOpened: false,
};

export const mindlyReviewsSlice = createSlice({
  name: 'mindlyReviews',
  initialState,
  reducers: {
    setIsModalOpened: (state, action: PayloadAction<boolean>) => {
      state.isModalOpened = state.isReviewed ? false : action.payload;
    },
    resetMindlyReviews: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(loadMindlyReviewThunk.fulfilled, (state, action) => {
      try {
        const { data } = action.payload;
        state.isReviewed = data?.rate > 0;
      } catch (error) {
        console.error(`loadMindlyReviewThunk: ${(error as Error).message}`);
      }
    });
    builder.addCase(reviewMindlyThunk.fulfilled, (state, action) => {
      try {
        const { data } = action.payload;
        state.isReviewed = data?.rate > 0 || !!data?.comment;
      } catch (error) {
        console.error(`reviewMindlyThunk: ${(error as Error).message}`);
      }
    });
  },
});

export default mindlyReviewsSlice.reducer;
export const { setIsModalOpened, resetMindlyReviews } = mindlyReviewsSlice.actions;
